import { css } from '@emotion/react';

/* ── Floating trigger button ── */
export const triggerButton = css`
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 9999;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: #4F46E5;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.24);
  }
`;

/* ── Chat panel ── */
export const panel = css`
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 9999;
  width: 380px;
  height: 560px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.25s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

/* ── Header ── */
export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #4F46E5;
  color: #fff;
  flex-shrink: 0;
`;

export const headerTitle = css`
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const headerActions = css`
  display: flex;
  gap: 4px;
`;

export const headerBtn = css`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
  }
`;

/* ── Messages area ── */
export const messagesArea = css`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }
`;

export const messageBubble = (isUser: boolean) => css`
  max-width: 85%;
  align-self: ${isUser ? 'flex-end' : 'flex-start'};
  padding: 10px 14px;
  border-radius: ${isUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px'};
  background: ${isUser ? '#4F46E5' : '#F3F4F6'};
  color: ${isUser ? '#fff' : '#1F2937'};
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`;

/* ── Buttons (FAQ options) ── */
export const buttonsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  align-self: flex-start;
  max-width: 90%;
`;

export const optionButton = css`
  background: #fff;
  border: 1px solid #D1D5DB;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;
  line-height: 1.4;

  &:hover {
    border-color: #4F46E5;
    background: #EEF2FF;
    color: #4338CA;
  }
`;

/* ── Input area ── */
export const inputArea = css`
  display: flex;
  padding: 12px 16px;
  gap: 8px;
  border-top: 1px solid #E5E7EB;
  background: #fff;
  flex-shrink: 0;
`;

export const textInput = css`
  flex: 1;
  border: 1px solid #D1D5DB;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 14px;
  outline: none;
  resize: none;
  font-family: inherit;
  min-height: 38px;
  max-height: 80px;

  &:focus {
    border-color: #4F46E5;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.12);
  }

  &::placeholder {
    color: #9CA3AF;
  }
`;

export const sendBtn = css`
  background: #4F46E5;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  font-weight: 500;

  &:hover {
    background: #4338CA;
  }

  &:disabled {
    background: #C7D2FE;
    cursor: not-allowed;
  }
`;

/* ── Loading dots ── */
export const loadingDots = css`
  display: flex;
  gap: 4px;
  align-self: flex-start;
  padding: 10px 14px;
  background: #F3F4F6;
  border-radius: 16px 16px 16px 4px;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #9CA3AF;
    animation: bounce 1.2s infinite;
  }
  span:nth-of-type(2) {
    animation-delay: 0.15s;
  }
  span:nth-of-type(3) {
    animation-delay: 0.3s;
  }

  @keyframes bounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-6px); }
  }
`;

/* ── Error banner ── */
export const errorBanner = css`
  padding: 8px 16px;
  background: #FEF2F2;
  color: #DC2626;
  font-size: 13px;
  text-align: center;
  flex-shrink: 0;
`;
